import React from "react";
import { Caption1, InfoSmallIcon, Input, InputPassword, Label, Tooltip } from "@activecollab/components";
import { Field, useFormikContext } from "formik";
import PropTypes from "prop-types";

const ClientFormInput = ({ type, name, label, caption, fieldRef }) => {
  const { errors, touched } = useFormikContext();
  return (
    <div className="tw-flex tw-flex-col tw-gap-1">
      <Field name={name}>
        {({ field, form }) => (
          <>
            <Label
              htmlFor={name}
              invalid={errors[name] && touched[name]}
            >
              {label}
            </Label>
            {type === "input" ? (
              <Input
                id={name}
                name={field.name}
                value={field.value}
                invalid={errors[name] && touched[name]}
                ref={(el) => (fieldRef.current[name] = el)}
                onChange={(e) => {
                  form.setFieldTouched(field.name, false);
                  form.setFieldValue(field.name, e.target.value);
                }}
                endAdornment={
                  errors[name] && touched[name] ? (
                    <Tooltip title={errors[name]}>
                      <InfoSmallIcon
                        fill="var(--red-alert)"
                        className="tw-cursor-help tw-mr-1"
                      />
                    </Tooltip>
                  ) : null
                }
              />
            ) : (
              <InputPassword
                autoFocus
                id={name}
                name={field.name}
                value={field.value}
                invalid={errors[name] && touched[name]}
                autoComplete="new-password"
                onChange={(value) => {
                  form.setFieldTouched(field.name, false);
                  form.setFieldValue(field.name, value);
                }}
                ref={(el) => (fieldRef.current[name] = el)}
                errorMessage={errors[name] && touched[name] ? errors[name] : null}
              />
            )}
            <Caption1 color="tertiary">{caption}</Caption1>
          </>
        )}
      </Field>
    </div>
  );
};
ClientFormInput.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["input", "password"]),
  label: PropTypes.string.isRequired,
  caption: PropTypes.string.isRequired,
  fieldRef: PropTypes.object,
};

ClientFormInput.defaultProps = {
  type: "input",
};

export default ClientFormInput;
